/**
 * Handles the functionality for displaying and hiding a slide-up modal.
 *
 * Features:
 * - Listens for clicks on elements with the `.slide-up-modal` class.
 * - Prevents the default behavior of the clicked element.
 * - Extracts the modal selector from the `href` attribute of the clicked element.
 * - Dynamically creates and appends an overlay `#slide-up-modal-overlay` if it does not exist.
 * - Displays the modal and overlay.
 * - Hides the modal and removes the overlay on overlay click.
 *
 * Usage:
 * - Add the `slide-up-modal` class to the trigger element (a).
 * - Set the `href` attribute of the trigger element to reference the modal's selector.
 * - Ensure the modal has a class that gets toggled (e.g., `active`) for its visibility.
 *
 * Example HTML setup:
 * <a href="#exampleModal" class="slide-up-modal">Open Modal</a>
 * <div id="exampleModal" class="modal">Your modal content here</div>
 *
 * Dependencies:
 * - jQuery library
 *
 * Note:
 * - Make sure the modal's hidden state is handled via CSS.
 */
( function( $ ) {
    $(function() {
        $('.slide-up-modal').click(function (e) {
            e.preventDefault();
            let modalSelector = $(this).attr('href');
            let modalOverlayId = 'slide-up-modal-overlay';

            if ($(`#${modalOverlayId}`).length === 0) {
                $('body').append('<div id="' + modalOverlayId + '"></div>');
            }
            $(`#${modalOverlayId}`)
                .fadeIn()
                .click(function () {
                    $(modalSelector).removeClass('active');
                    $(this).fadeOut(function () {
                        $(this).remove();
                    });
                });

            $(modalSelector).addClass('active');
        });
    })
})(jQuery)
